import type { IAnalyticsPosition } from 'types';

type FindBestPositionParams = {
  providerIndex: number;
  positions: IAnalyticsPosition[];
};

export const findBestPosition = ({
  providerIndex,
  positions,
}: FindBestPositionParams): IAnalyticsPosition => {
  let minPrice = Infinity;
  let bestPosition: IAnalyticsPosition | null = null;

  positions.forEach(position => {
    const price = position.prices[providerIndex] * position.count;
    if (price > 0 && price < minPrice) {
      minPrice = price;
      bestPosition = position;
    }
  });

  return bestPosition;
};
